import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Historique } from './historique.model';
import { HistoriquePopupService } from './historique-popup.service';
import { HistoriqueService } from './historique.service';
@Component({
    selector: 'jhi-historique-dialog',
    templateUrl: './historique-dialog.component.html'
})
export class HistoriqueDialogComponent implements OnInit {

    historique: Historique;
    authorities: any[];
    isSaving: boolean;
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private historiqueService: HistoriqueService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['historique']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.historique.id !== undefined) {
            this.historiqueService.update(this.historique)
                .subscribe((res: Historique) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.historiqueService.create(this.historique)
                .subscribe((res: Historique) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: Historique) {
        this.eventManager.broadcast({ name: 'historiqueListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-historique-popup',
    template: ''
})
export class HistoriquePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private historiquePopupService: HistoriquePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.historiquePopupService
                    .open(HistoriqueDialogComponent, params['id']);
            } else {
                this.modalRef = this.historiquePopupService
                    .open(HistoriqueDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique-dialog.component.ts